<template>
  
    <div >
      <onedevicepolicy></onedevicepolicy>
      <!-- <onedevicepolicy v-if="$store.state.currentOrg.org.oneDevicePolicy"></onedevicepolicy>
      <twodevicepolicy v-else-if="!$store.state.currentOrg.org.oneDevicePolicy"></twodevicepolicy> -->
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import oneDevicePolicyServiceAccounts from '@/components/OneDeviceServiceAccounts.vue';
import twoDevicePolicyServiceAccounts from '@/components/TwoDeviceServiceAccounts.vue';

export default {
  components: {
    onedevicepolicy: oneDevicePolicyServiceAccounts,
    twodevicepolicy: twoDevicePolicyServiceAccounts
  },
  created(){
    
  }
};
</script>

